import HelpSearch from '@/customComponents/helpComponents/HelpSearch.jsx'
import FaqList from '@/customComponents/helpComponents/FaqList.jsx'
import ElfsightChat from '@/customComponents/helpComponents/ElfsightChat.jsx'

function Help() {
    return (
        // max-md:pb-8 — on mobile the chat card is the last thing in the stack and ends
        // flush against the viewport edge. Desktop doesn't need it: the chat column is
        // sticky with `md:bottom-8`, which already holds it clear.
        <div className="flex flex-col gap-8 max-md:gap-4 max-md:pb-4">
            <div className="grid grid-cols-12 gap-8 items-end max-md:gap-0">
                <div className="col-span-12 md:col-span-8">
                    <HelpSearch/>
                    <FaqList/>
                </div>
                {/* Chat box sticks while the (long) FAQ column scrolls; scrolls
                    internally if taller than the viewport. */}
                <div className="col-span-12 md:col-span-4 mt-8 max-md:mt-4 md:sticky md:bottom-8 md:self-end md:max-h-[calc(100dvh-4rem)] md:overflow-y-auto">
                    <ElfsightChat/>
                </div>
            </div>
        </div>
    )
}

export default Help
